import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import { CssBaseline } from '@mui/material';
import { ErrorBoundary, Layout } from './components';
import { Dashboard, TenantsPage, SettingsPage, NotFoundPage } from './pages';
import { initializeAmplify } from './utils/amplify-config';
import { theme } from './theme';
import { Authenticator } from '@aws-amplify/ui-react';
import { NotificationProvider } from './contexts/NotificationContext';
import '@aws-amplify/ui-react/styles.css';

// Initialize Amplify on app startup
// updated again
initializeAmplify();

function App() {
    return (
        <ThemeProvider theme={theme}>
            <CssBaseline />
            <ErrorBoundary>
                <NotificationProvider>
                    <Authenticator
                        hideSignUp
                        components={{
                            Header() {
                                return <h1 style={{ textAlign: 'center' }}>Welcome to Tenant Management</h1>;
                            },
                            Footer() {
                                return (
                                    <div style={{ textAlign: 'center' }}>
                                        <p>© 2025 Tenant Management</p>
                                    </div>
                                );
                            },
                        }}
                    >
                        {({ signOut, user }) => (
                            <Router>
                                <Layout>
                                    <Routes>
                                        <Route path="/" element={<Dashboard />} />
                                        <Route path="/tenants" element={<TenantsPage />} />
                                        <Route path="/settings" element={<SettingsPage />} />
                                        <Route path="*" element={<NotFoundPage />} />
                                    </Routes>
                                </Layout>
                            </Router>
                        )}
                    </Authenticator>
                </NotificationProvider>
            </ErrorBoundary>
        </ThemeProvider>
    );
}

export default App;
